import React from "react";
import { change, Field, FieldArray } from "redux-form";
import { IconButton, Tooltip } from "@mui/material";

import ConsequencesSection from "./ConsequencesSection";
import { customTextarea } from "../../../common/customTextarea";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch } from "react-redux";

import styles from "../../v2Styles.module.css";

export default function HazardsSection({ fields, consequences, likelihoods, loading, loadingData, meta: { error }, actIndex, disabled, formName }) {

  const dispatch = useDispatch();
  const onMoveRow = (dragIndex, hoverIndex) => {
    if (dragIndex !== hoverIndex) {
      fields.move(dragIndex, hoverIndex);
      dispatch(change(formName, "_v", Date.now()))
    }
  }

  return (
    <div className="">
      {error ? <div className="error mt-2">{error}</div> : ""}
      {fields.map((member, index) => (
        <div key={index} className={""}>
          <div className="container-fluid px-0 border-bottom my-2">
            <div className="row align-center">
              <div className="col-6">
                <div>
                  <div className={styles.Label}>Hazard</div>
                  <Field disabled={loading || disabled} name={`${member}.hazard_name`} rows={3} component={customTextarea} className={`${styles.TextArea} ${styles.AutoHeight} ${styles.Rows4}`} />
                  <div className="d-flex" style={{}}>
                    <Tooltip title="Delete hazard">
                      <span>
                        <IconButton disabled={loading || disabled || fields.length <= 1} onClick={(e) => { e.stopPropagation(); e.preventDefault(); fields.remove(index) }} className={`${styles.IconBtn} ${styles.DangerColor} p-1`} style={{ height: "fit-content" }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                            <path fill="currentColor" d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z" />
                          </svg>
                        </IconButton>
                      </span>
                    </Tooltip>
                    <div className="d-flex" style={{}}>
                      <Tooltip title="Move hazard up">
                        <span>
                          <IconButton disabled={loading || disabled || fields.length <= 1 || index === 0} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMoveRow(index, index - 1) }} className={`${styles.IconBtn} ${styles.SecondaryColor} p-1`} sx={{ height: "fit-content", paddingRight: "0px !important" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                              <path fill="currentColor" d="M297.4 201.4C309.9 188.9 330.2 188.9 342.7 201.4L502.7 361.4C515.2 373.9 515.2 394.2 502.7 406.7C490.2 419.2 469.9 419.2 457.4 406.7L320 269.3L182.6 406.6C170.1 419.1 149.8 419.1 137.3 406.6C124.8 394.1 124.8 373.8 137.3 361.3L297.3 201.3z" />
                            </svg>
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Move hazard down">
                        <span>
                          <IconButton disabled={loading || disabled || fields.length <= 1 || index === fields.length - 1} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMoveRow(index, index + 1) }} className={`${styles.IconBtn} ${styles.SecondaryColor} p-1`} style={{ height: "fit-content" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                              <path fill="currentColor" d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z" />
                            </svg>
                          </IconButton>
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 border-left mb-2">
                <DndProvider backend={HTML5Backend}>
                  <FieldArray
                    name={`${member}.consequences`}
                    loadingData={loadingData}
                    consequences={consequences}
                    likelihoods={likelihoods}
                    loading={loading}
                    disabled={disabled}
                    formName={formName}
                    hazIndex={index}
                    actIndex={actIndex}
                    component={ConsequencesSection}
                    fieldName={`${member}.consequences`}
                  />
                </DndProvider>
              </div>
            </div>
          </div>
        </div>
      ))}
      <button type="button" className={`${styles.PrimaryButton} ${styles.SmallButton} mb-2`} disabled={loading || disabled} onClick={() => fields.push({ consequences: [{ id: Date.now(), isNew: true }] })}>
        Add Hazard
      </button>
    </div>
  )
}